import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-thought-record-question-text-list-guided',
    templateUrl: 'guided.component.html',
    styleUrls: ['guided.component.scss']
})
export class GuidedComponent implements OnInit {

    @Input() steps: string[];
    @Output() answered: EventEmitter<any>;

    index: number;
    value: string;
    texts: string[];

    constructor() {
        this.answered = new EventEmitter<any>();
    }

    ngOnInit(): void {
        this.value = '';
        this.index = 0;
        this.texts = [];
    }

    skip() {
        this.index++;
    }

    next() {
        this.texts.push(this.value);
        this.value = '';
        this.index++;
    }

    continue() {
        this.answered.emit(this.texts);
    }
}
